//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FilterRightDrawer from './components/FilterRightDrawer.vue'
import StatsFooter from './components/StatsFooter.vue'
import DebugDialog from './components/DebugDialog.vue'

export default {
  name: 'LayoutDefault',
  components: {
    FilterRightDrawer,
    StatsFooter,
    DebugDialog
  },
  data () {
    return {
      leftDrawerOpen: false,
      rightDrawerOpen: false,
      
      debug: false
    }
  },
  metaInfo() {
    return {
      title: "AppMainPage"
    }
  },
  created() {
    console.log("-------------------------------")
    console.log(window.location.host)
    this.$analytics.logEvent("App Created "+window.location.host)
    console.log("-------------------------------")    
  }
}
